// ════════════════════════════════════════════════════════════════════════════
// components/CRM/OportunidadesList.jsx
// ✅ CORREGIDO: Tabla de oportunidades con pipeline visual y acciones mejoradas
// ════════════════════════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  CircularProgress,
  Alert,
  LinearProgress,
  Tooltip,

  alpha,
  Avatar,
  Card,
  CardContent,
  TablePagination,
  InputAdornment,

  Switch,
  FormControlLabel,

} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  ArrowForward as ArrowForwardIcon,
  FilterList as FilterListIcon,
  TrendingUp as TrendingUpIcon,
  Download as DownloadIcon,
  Visibility as VisibilityIcon,

    MonetizationOn as MonetizationOnIcon,
  CalendarMonth as CalendarMonthIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  Phone as PhoneIcon
} from '@mui/icons-material';
import { 
  getOportunidades, 
  getOportunidadById, 
  createOportunidad, 
  updateOportunidad, 
  moverEtapaOportunidad,
  reasignarOportunidad,
} from '../../services/crmService';
import { toast } from 'react-toastify';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// ════════════════════════════════════════════════════════════════════════════
// CONFIGURACIÓN DE ETIQUETAS Y COLORES - MEJORADA
// ════════════════════════════════════════════════════════════════════════════

const ETAPAS_CONFIG = {
  contacto_inicial: { 
    label: 'Contacto Inicial', 
    color: '#3b82f6',
    bgcolor: '#dbeafe',
    icon: <PhoneIcon />
  },
  necesidad_validada: { 
    label: 'Necesidad Validada', 
    color: '#8b5cf6',
    bgcolor: '#ede9fe',
    icon: <TrendingUpIcon />
  },
  propuesta_enviada: { 
    label: 'Propuesta Enviada', 
    color: '#f59e0b',
    bgcolor: '#fef3c7',
    icon: <VisibilityIcon />
  },
  negociacion: { 
    label: 'En Negociación', 
    color: '#ec4899',
    bgcolor: '#fce7f3',
    icon: <PersonIcon />
  },
  cerrado_ganado: { 
    label: 'Cerrado - Ganado', 
    color: '#10b981',
    bgcolor: '#d1fae5',
    icon: <MonetizationOnIcon />
  },
  cerrado_perdido: { 
    label: 'Cerrado - Perdido', 
    color: '#ef4444',
    bgcolor: '#fee2e2',
    icon: <DeleteIcon />
  }
};

const ETAPAS_ORDEN = [
  'contacto_inicial',
  'necesidad_validada',
  'propuesta_enviada',
  'negociacion',
  'cerrado_ganado',
  'cerrado_perdido'
];

const VALOR_RANGOS = [
  { label: 'Todos', min: 0, max: Infinity },
  { label: 'Menos de $10K', min: 0, max: 10000 },
  { label: '$10K - $50K', min: 10000, max: 50000 },
  { label: '$50K - $100K', min: 50000, max: 100000 },
  { label: 'Más de $100K', min: 100000, max: Infinity }
];

// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE DE FILTROS AVANZADOS - NUEVO
// ════════════════════════════════════════════════════════════════════════════

const FiltrosAvanzados = ({ filtros, onFiltroChange, onClear }) => {
  const [expanded, setExpanded] = useState(false);
  
  return (
    <Card sx={{ mb: 2, borderRadius: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FilterListIcon sx={{ color: '#64748b' }} />
            <Typography variant="subtitle2" fontWeight="bold" color="#64748b">
              Filtros Avanzados
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              size="small" 
              onClick={() => setExpanded(!expanded)}
              endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              sx={{ fontSize: '0.75rem' }}
            >
              {expanded ? 'Ocultar' : 'Mostrar'}
            </Button>
            
            <Button 
              size="small" 
              onClick={onClear}
              sx={{ 
                fontSize: '0.75rem',
                color: '#ef4444'
              }}
            >
              Limpiar
            </Button>
          </Box>
        </Box>
        
        <Collapse in={expanded}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Rango de Valor</InputLabel>
                <Select
                  value={filtros.valorRango || ''}
                  label="Rango de Valor"
                  onChange={(e) => onFiltroChange('valorRango', e.target.value)}
                >
                  {VALOR_RANGOS.map((rango, index) => (
                    <MenuItem key={index} value={index}>
                      {rango.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField
                fullWidth
                size="small"
                label="Probabilidad Mínima"
                type="number"
                value={filtros.probabilidadMin || ''}
                onChange={(e) => onFiltroChange('probabilidadMin', e.target.value)}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }}
              />
            </Grid>
            
            <Grid size={{ xs: 12, md: 4 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={filtros.soloVencidas || false}
                    onChange={(e) => onFiltroChange('soloVencidas', e.target.checked)}
                    size="small"
                  />
                }
                label="Solo vencidas"
                sx={{ mt: 1 }}
              />
            </Grid>
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL - COMPLETAMENTE CORREGIDO
// ════════════════════════════════════════════════════════════════════════════

const OportunidadesList = () => {
  // ════════════════════════════════════════════════════════════════════════
  // STATE PRINCIPAL
  // ════════════════════════════════════════════════════════════════════════
  
  const [oportunidades, setOportunidades] = useState([]);
  const [filteredOportunidades, setFilteredOportunidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Filtros
  const [filtros, setFiltros] = useState({
    etapa: '',
    responsable_id: '',
    search: '',
    valorRango: '',
    probabilidadMin: '',
    soloVencidas: false
  });
  
  // Paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Modal de formulario
  const [modalOpen, setModalOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [formData, setFormData] = useState({
    prospecto_id: '',
    etapa: 'contacto_inicial',
    valor_estimado: '',
    probabilidad: 10,
    fecha_cierre_estimada: '',
    responsable_id: '',
    competidor: '',
    notas: ''
  });
  
  // Modal de mover etapa
  const [modalEtapaOpen, setModalEtapaOpen] = useState(false);
  const [oportunidadEtapa, setOportunidadEtapa] = useState(null);
  const [motivoPerdida, setMotivoPerdida] = useState('');
  
  // ════════════════════════════════════════════════════════════════════════
  // EFFECTS
  // ════════════════════════════════════════════════════════════════════════
  
  useEffect(() => {
    cargarOportunidades();
  }, []);
  
  useEffect(() => {
    aplicarFiltros();
  }, [filtros, oportunidades]);
  
  // ════════════════════════════════════════════════════════════════════════
  // FUNCIONES PRINCIPALES - CORREGIDAS
  // ════════════════════════════════════════════════════════════════════════
  
  const cargarOportunidades = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await getOportunidades(filtros);
      
      // Backend devuelve: { success: true, data: { count: 44, oportunidades: [...] } }
      const oportunidadesData = response.data?.data?.oportunidades || [];
      
      console.log('📦 Oportunidades cargadas:', oportunidadesData.length);
      setOportunidades(oportunidadesData);
    } catch (err) {
      console.error('Error cargando oportunidades:', err);
      setError('Error al cargar las oportunidades. Verifica tu conexión.');
      toast.error('❌ Error al cargar las oportunidades');
    } finally {
      setLoading(false);
    }
  };
  
  const aplicarFiltros = () => {
    let filtered = [...oportunidades];
    
    // Filtro por búsqueda
    if (filtros.search) {
      const searchLower = filtros.search.toLowerCase();
      filtered = filtered.filter(oportunidad =>
        (oportunidad.prospecto?.nombre?.toLowerCase().includes(searchLower)) ||
        (oportunidad.prospecto?.empresa?.toLowerCase().includes(searchLower)) ||
        (oportunidad.prospecto?.email?.toLowerCase().includes(searchLower))
      );
    }
    
    // Filtro por etapa
    if (filtros.etapa) {
      filtered = filtered.filter(oportunidad => oportunidad.etapa === filtros.etapa);
    }
    
    // Filtro por rango de valor
    if (filtros.valorRango !== '' && VALOR_RANGOS[filtros.valorRango]) {
      const rango = VALOR_RANGOS[filtros.valorRango];
      filtered = filtered.filter(oportunidad => {
        const valor = parseFloat(oportunidad.valor_estimado || 0);
        return valor >= rango.min && valor <= rango.max;
      });
    }
    
    // Filtro por probabilidad mínima
    if (filtros.probabilidadMin) {
      const minProb = parseInt(filtros.probabilidadMin);
      filtered = filtered.filter(oportunidad => 
        (oportunidad.probabilidad || 0) >= minProb
      );
    }
    
    // Filtro por vencidas
    if (filtros.soloVencidas) {
      filtered = filtered.filter(oportunidad => {
        const diasSinActividad = Math.floor(
          (new Date() - new Date(oportunidad.actualizado_en)) / (1000 * 60 * 60 * 24)
        );
        return diasSinActividad > 7 && !oportunidad.etapa.includes('cerrado');
      });
    }
    
    setFilteredOportunidades(filtered);
    setPage(0); // Resetear a primera página al filtrar
  };
  
  const handleFiltroChange = (campo, valor) => {
    setFiltros(prev => ({ ...prev, [campo]: valor }));
  };
  
  const handleClearFiltros = () => {
    setFiltros({
      etapa: '',
      responsable_id: '',
      search: '',
      valorRango: '',
      probabilidadMin: '',
      soloVencidas: false
    });
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const abrirModalCrear = () => {
    setEditandoId(null);
    setFormData({
      prospecto_id: '',
      etapa: 'contacto_inicial',
      valor_estimado: '',
      probabilidad: 10,
      fecha_cierre_estimada: '',
      responsable_id: '',
      competidor: '',
      notas: ''
    });
    setModalOpen(true);
  };
  
  const abrirModalEditar = async (oportunidad) => {
    try {
      const response = await getOportunidadById(oportunidad.id);
      
      // Backend devuelve: { success: true, data: { oportunidad: {...} } }
      const data = response.data?.data?.oportunidad 
                || response.data?.oportunidad 
                || response.data?.data 
                || response.data 
                || oportunidad; // fallback: usar los datos que ya tenemos
      
      setEditandoId(oportunidad.id);
      setFormData({
        prospecto_id: data.prospecto_id || '',
        etapa: data.etapa || 'contacto_inicial',
        valor_estimado: data.valor_estimado || '',
        probabilidad: data.probabilidad || 10,
        fecha_cierre_estimada: data.fecha_cierre_estimada || '',
        responsable_id: data.responsable_id || '',
        competidor: data.competidor || '',
        notas: data.notas || ''
      });
      setModalOpen(true);
    } catch (err) {
      console.error('Error cargando oportunidad:', err);
      toast.error('❌ Error al cargar la oportunidad');
    }
  };
  
  const cerrarModal = () => {
    setModalOpen(false);
    setEditandoId(null);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validaciones básicas
    if (!formData.prospecto_id || !formData.responsable_id) {
      toast.error('❌ Prospecto y responsable son requeridos');
      return;
    }
    
    try {
      // ✅ Limpiar fecha inválida antes de enviar
      const datosLimpios = {
        ...formData,
        fecha_cierre_estimada: formData.fecha_cierre_estimada && formData.fecha_cierre_estimada !== 'Invalid date'
          ? formData.fecha_cierre_estimada
          : null,
        valor_estimado: formData.valor_estimado ? parseFloat(formData.valor_estimado) : null
      };

      if (editandoId) {
        await updateOportunidad(editandoId, datosLimpios);
        toast.success('✅ Oportunidad actualizada exitosamente');
      } else {
        await createOportunidad(datosLimpios);
        toast.success('✅ Oportunidad creada exitosamente');
      }
      
      cerrarModal();
      cargarOportunidades();
    } catch (err) {
      console.error('Error guardando oportunidad:', err);
      toast.error(`❌ Error al ${editandoId ? 'actualizar' : 'crear'} oportunidad`);
    }
  };
  
  const handleMoverEtapa = (oportunidad, nuevaEtapa) => {
    setOportunidadEtapa({ ...oportunidad, nuevaEtapa });
    
    // Si se cierra como perdido, pedir motivo
    if (nuevaEtapa === 'cerrado_perdido') {
      setModalEtapaOpen(true);
      setMotivoPerdida('');
    } else {
      // Mover directamente
      confirmarMoverEtapa(nuevaEtapa, '');
    }
  };
  
  const confirmarMoverEtapa = async (nuevaEtapa, motivo) => {
    try {
      await moverEtapaOportunidad(oportunidadEtapa.id, { 
        etapa_nueva: nuevaEtapa,
        motivo: motivo || null
      });
      
      toast.success(`✅ Oportunidad movida a: ${ETAPAS_CONFIG[nuevaEtapa].label}`);
      setModalEtapaOpen(false);
      cargarOportunidades();
    } catch (err) {
      console.error('Error moviendo etapa:', err);
      toast.error('❌ Error al mover la oportunidad');
    }
  };
  
  const handleReasignar = async (id, nuevoResponsableId) => {
    if (!nuevoResponsableId) {
      toast.error('❌ Seleccione un responsable válido');
      return;
    }
    
    try {
      await reasignarOportunidad(id, { nuevo_responsable_id: nuevoResponsableId });
      toast.success('✅ Oportunidad reasignada exitosamente');
      cargarOportunidades();
    } catch (err) {
      console.error('Error reasignando:', err);
      toast.error('❌ Error al reasignar la oportunidad');
    }
  };
  
  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta oportunidad?')) {
      return;
    }
    
    try {
      await updateOportunidad(id, { _delete: true });
      toast.success('✅ Oportunidad eliminada exitosamente');
      cargarOportunidades();
    } catch (err) {
      console.error('Error eliminando oportunidad:', err);
      toast.error('❌ Error al eliminar la oportunidad');
    }
  };
  
  const handleRefresh = () => {
    cargarOportunidades();
    toast.info('🔄 Actualizando oportunidades...');
  };
  
  const handleExport = () => {
    toast.info('📤 Preparando exportación...');
    // Aquí iría la lógica de exportación
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  // Calcular estadísticas del pipeline
  const calcularEstadisticas = () => {
    const stats = {
      total: filteredOportunidades.length,
      valorTotal: 0,
      porEtapa: {},
      oportunidadesVencidas: 0
    };
    
    ETAPAS_ORDEN.forEach(etapa => {
      stats.porEtapa[etapa] = {
        count: 0,
        valor: 0
      };
    });
    
    filteredOportunidades.forEach(oportunidad => {
      const etapa = oportunidad.etapa;
      if (stats.porEtapa[etapa]) {
        stats.porEtapa[etapa].count++;
        stats.porEtapa[etapa].valor += parseFloat(oportunidad.valor_estimado || 0);
      }
      stats.valorTotal += parseFloat(oportunidad.valor_estimado || 0);
      
      // Contar vencidas
      const diasSinActividad = Math.floor(
        (new Date() - new Date(oportunidad.actualizado_en)) / (1000 * 60 * 60 * 24)
      );
      if (diasSinActividad > 7 && !oportunidad.etapa.includes('cerrado')) {
        stats.oportunidadesVencidas++;
      }
    });
    
    return stats;
  };
  
  const stats = calcularEstadisticas();
  
  // Obtener datos para la página actual
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const oportunidadesPaginadas = filteredOportunidades.slice(startIndex, endIndex);
  
  // ════════════════════════════════════════════════════════════════════════
  // RENDER
  // ════════════════════════════════════════════════════════════════════════
  
  return (
    <Box sx={{ p: 3, bgcolor: '#f8fafc', minHeight: '100vh' }}>
      {/* Título y botones principales */}
      <Box sx={{ 
        mb: 3,
        bgcolor: 'white',
        p: 3,
        borderRadius: 2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="h4" sx={{ 
              fontWeight: 'bold', 
              color: '#1e293b',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              💼 Pipeline de Oportunidades
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Gestión completa del pipeline comercial
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleRefresh}
              disabled={loading}
              sx={{ 
                borderColor: '#64748b',
                color: '#64748b'
              }}
            >
              Actualizar
            </Button>
            
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={handleExport}
              sx={{ 
                borderColor: '#10b981',
                color: '#10b981'
              }}
            >
              Exportar
            </Button>
            
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={abrirModalCrear}
              sx={{ 
                bgcolor: '#3b82f6', 
                '&:hover': { bgcolor: '#2563eb' },
                color: 'white'
              }}
            >
              Nueva Oportunidad
            </Button>
          </Box>
        </Box>
        
        {/* Estadísticas rápidas */}
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#eff6ff', borderRadius: 2 }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h4" fontWeight="bold" color="#1d4ed8">
                  {stats.total}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  Total
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#f0f9ff', borderRadius: 2 }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h4" fontWeight="bold" color="#0ea5e9">
                  {stats.porEtapa.contacto_inicial?.count || 0}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  Contacto Inicial
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#fef3c7', borderRadius: 2 }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h4" fontWeight="bold" color="#d97706">
                  {stats.porEtapa.negociacion?.count || 0}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  En Negociación
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#d1fae5', borderRadius: 2 }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h4" fontWeight="bold" color="#059669">
                  {stats.porEtapa.cerrado_ganado?.count || 0}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  Ganadas
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#fee2e2', borderRadius: 2 }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h4" fontWeight="bold" color="#dc2626">
                  {stats.oportunidadesVencidas}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  Vencidas
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Card sx={{ bgcolor: '#f8fafc', borderRadius: 2, border: '2px solid #e2e8f0' }}>
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h5" fontWeight="bold" color="#059669">
                  ${Math.round(stats.valorTotal).toLocaleString('es-DO')}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  Valor Total
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      
      {/* Filtros básicos */}
      <Card sx={{ mb: 2, borderRadius: 2 }}>
        <CardContent sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar por prospecto, empresa, email..."
                value={filtros.search}
                onChange={(e) => handleFiltroChange('search', e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#64748b' }} />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 }
                }}
              />
            </Grid>
            
            <Grid size={{ xs: 12, md: 3 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Etapa</InputLabel>
                <Select
                  value={filtros.etapa}
                  label="Etapa"
                  onChange={(e) => handleFiltroChange('etapa', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Todas las etapas</MenuItem>
                  {ETAPAS_ORDEN.map(etapa => {
                    const config = ETAPAS_CONFIG[etapa];
                    return (
                      <MenuItem key={etapa} value={etapa}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ color: config.color }}>{config.icon}</Box>
                          {config.label}
                        </Box>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid size={{ xs: 12, md: 3 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Responsable</InputLabel>
                <Select
                  value={filtros.responsable_id}
                  label="Responsable"
                  onChange={(e) => handleFiltroChange('responsable_id', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="1">Juan Pérez</MenuItem>
                  <MenuItem value="2">María García</MenuItem>
                  <MenuItem value="3">Carlos Rodríguez</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid size={{ xs: 12, md: 2 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleClearFiltros}
                sx={{ 
                  borderColor: '#64748b',
                  color: '#64748b',
                  height: '40px',
                  borderRadius: 2
                }}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      
      {/* Filtros avanzados */}
      <FiltrosAvanzados 
        filtros={filtros}
        onFiltroChange={handleFiltroChange}
        onClear={handleClearFiltros}
      />
      
      {/* Mensaje de error */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 2, borderRadius: 2 }}
          action={
            <Button color="inherit" size="small" onClick={cargarOportunidades}>
              Reintentar
            </Button>
          }
        >
          {error}
        </Alert>
      )}
      
      {/* Tabla de oportunidades */}
      <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead sx={{ bgcolor: '#3b82f6' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>#</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Prospecto</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Etapa</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Valor Estimado</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Responsable</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Probabilidad</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Cierre Estimado</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14 }}>Última Actualización</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: 14, textAlign: 'center' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Box sx={{ py: 8 }}>
                      <CircularProgress sx={{ color: '#3b82f6', mb: 2 }} />
                      <Typography variant="body2" color="text.secondary">
                        Cargando oportunidades...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : filteredOportunidades.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 8 }}>
                    <Box sx={{ textAlign: 'center', color: '#94a3b8' }}>
                      <BusinessIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
                      <Typography variant="body1" gutterBottom>
                        No hay oportunidades {filtros.search ? 'que coincidan con la búsqueda' : 'registradas'}
                      </Typography>
                      {Object.values(filtros).some(val => val !== '' && val !== false) && (
                        <Button 
                          variant="outlined" 
                          onClick={handleClearFiltros}
                          sx={{ mt: 2 }}
                        >
                          Limpiar filtros
                        </Button>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                oportunidadesPaginadas.map((oportunidad, index) => {
                  const etapaConfig = ETAPAS_CONFIG[oportunidad.etapa] || ETAPAS_CONFIG.contacto_inicial;
                  const probabilidad = oportunidad.probabilidad || 0;
                  const diasSinActividad = Math.floor(
                    (new Date() - new Date(oportunidad.actualizado_en)) / (1000 * 60 * 60 * 24)
                  );
                  const necesitaAtencion = diasSinActividad > 7 && !oportunidad.etapa.includes('cerrado');
                  
                  return (
                    <TableRow 
                      key={oportunidad.id} 
                      hover
                      sx={{ 
                        '&:nth-of-type(even)': { bgcolor: '#f8fafc' },
                        '&:hover': { bgcolor: '#f1f5f9' },
                        borderLeft: necesitaAtencion ? '4px solid #ef4444' : 'none'
                      }}
                    >
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {startIndex + index + 1}
                        </Typography>
                      </TableCell>
                      
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar 
                            sx={{ 
                              width: 32, 
                              height: 32, 
                              fontSize: '0.875rem',
                              bgcolor: alpha(etapaConfig.color, 0.1),
                              color: etapaConfig.color
                            }}
                          >
                            {oportunidad.prospecto?.nombre?.charAt(0) || 'P'}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight="bold">
                              {oportunidad.prospecto?.nombre || 'Sin nombre'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {oportunidad.prospecto?.empresa || '-'}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      
                      <TableCell>
                        <Chip 
                          label={etapaConfig.label}
                          size="small"
                          sx={{ 
                            bgcolor: alpha(etapaConfig.color, 0.1),
                            color: etapaConfig.color,
                            fontWeight: 'bold',
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold" color="#059669">
                          ${Number(oportunidad.valor_estimado || 0).toLocaleString('es-DO', { 
                            minimumFractionDigits: 2 
                          })}
                        </Typography>
                      </TableCell>
                      
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar 
                            sx={{ 
                              width: 24, 
                              height: 24, 
                              fontSize: '0.75rem',
                              bgcolor: '#3b82f6',
                              color: 'white'
                            }}
                          >
                            {oportunidad.responsable?.nombre?.charAt(0) || 'U'}
                          </Avatar>
                          <Typography variant="body2" fontSize="0.875rem">
                            {oportunidad.responsable?.nombre || '-'}
                          </Typography>
                        </Box>
                      </TableCell>
                      
                      <TableCell>
                        <Box sx={{ width: 100 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              {probabilidad}%
                            </Typography>
                            {necesitaAtencion && (
                              <Tooltip title={`${diasSinActividad} días sin actividad`}>
                                <WarningIcon sx={{ color: '#ef4444', fontSize: '0.875rem' }} />
                              </Tooltip>
                            )}
                          </Box>
                          <LinearProgress 
                            variant="determinate" 
                            value={probabilidad} 
                            sx={{ 
                              height: 6, 
                              bgcolor: '#e2e8f0',
                              borderRadius: 3,
                              '& .MuiLinearProgress-bar': { 
                                bgcolor: probabilidad > 70 ? '#10b981' : 
                                       probabilidad > 40 ? '#f59e0b' : '#ef4444',
                                borderRadius: 3
                              }
                            }} 
                          />
                        </Box>
                      </TableCell>
                      
                      <TableCell>
                        {oportunidad.fecha_cierre_estimada ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CalendarMonthIcon fontSize="small" sx={{ color: '#64748b' }} />
                            <Typography variant="body2" fontSize="0.875rem">
                              {new Date(oportunidad.fecha_cierre_estimada).toLocaleDateString('es-DO')}
                            </Typography>
                          </Box>
                        ) : '-'}
                      </TableCell>
                      
                      <TableCell>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(oportunidad.actualizado_en).toLocaleDateString('es-DO')}
                        </Typography>
                      </TableCell>
                      
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                          {/* Botón Mover Siguiente */}
                          {ETAPAS_CONFIG[oportunidad.etapa]?.next && (
                            <Tooltip title={`Mover a ${ETAPAS_CONFIG[ETAPAS_CONFIG[oportunidad.etapa].next].label}`}>
                              <IconButton 
                                size="small" 
                                sx={{ 
                                  color: '#3b82f6',
                                  bgcolor: alpha('#3b82f6', 0.1)
                                }}
                                onClick={() => handleMoverEtapa(oportunidad, ETAPAS_CONFIG[oportunidad.etapa].next)}
                              >
                                <ArrowForwardIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          
                          {/* Botón Editar */}
                          <Tooltip title="Editar">
                            <IconButton 
                              size="small" 
                              sx={{ 
                                color: '#f59e0b',
                                bgcolor: alpha('#f59e0b', 0.1)
                              }}
                              onClick={() => abrirModalEditar(oportunidad)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          
                          {/* Botón Eliminar */}
                          <Tooltip title="Eliminar">
                            <IconButton 
                              size="small" 
                              sx={{ 
                                color: '#ef4444',
                                bgcolor: alpha('#ef4444', 0.1)
                              }}
                              onClick={() => handleDelete(oportunidad.id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Paginación */}
        {filteredOportunidades.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredOportunidades.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Filas por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{ 
              borderTop: '1px solid #e2e8f0',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                fontSize: '0.875rem'
              }
            }}
          />
        )}
      </Card>
      
      {/* Modal de formulario */}
      <Dialog open={modalOpen} onClose={cerrarModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#3b82f6', color: 'white', fontWeight: 'bold', fontSize: '1.25rem' }}>
          {editandoId ? '✏️ Editar Oportunidad' : '➕ Nueva Oportunidad'}
        </DialogTitle>
        
        <form onSubmit={handleSubmit}>
          <DialogContent sx={{ p: 3 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  required
                  label="ID del Prospecto *"
                  name="prospecto_id"
                  type="number"
                  value={formData.prospecto_id}
                  onChange={handleInputChange}
                  size="small"
                  helperText="ID del prospecto asociado"
                />
              </Grid>
              
              <Grid size={{ xs: 12, md: 6 }}>
                <FormControl fullWidth size="small" required>
                  <InputLabel>Etapa *</InputLabel>
                  <Select
                    name="etapa"
                    value={formData.etapa}
                    label="Etapa *"
                    onChange={handleInputChange}
                  >
                    {ETAPAS_ORDEN.map(etapa => {
                      const config = ETAPAS_CONFIG[etapa];
                      return (
                        <MenuItem key={etapa} value={etapa}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ color: config.color }}>{config.icon}</Box>
                            {config.label}
                          </Box>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Valor Estimado"
                  name="valor_estimado"
                  type="number"
                  value={formData.valor_estimado}
                  onChange={handleInputChange}
                  size="small"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                  }}
                />
              </Grid>
              
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Probabilidad (%)"
                  name="probabilidad"
                  type="number"
                  value={formData.probabilidad}
                  onChange={handleInputChange}
                  size="small"
                  inputProps={{ min: 0, max: 100 }}
                  helperText="0-100%"
                />
              </Grid>
              
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Fecha Cierre Estimada"
                  name="fecha_cierre_estimada"
                  type="date"
                  value={formData.fecha_cierre_estimada}
                  onChange={handleInputChange}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  required
                  label="Responsable (ID) *"
                  name="responsable_id"
                  type="number"
                  value={formData.responsable_id}
                  onChange={handleInputChange}
                  size="small"
                  helperText="ID del vendedor responsable"
                />
              </Grid>
              
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Competidor"
                  name="competidor"
                  value={formData.competidor}
                  onChange={handleInputChange}
                  size="small"
                />
              </Grid>
              
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Notas"
                  name="notas"
                  value={formData.notas}
                  onChange={handleInputChange}
                  size="small"
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          </DialogContent>
          
          <DialogActions sx={{ p: 2 }}>
            <Button 
              onClick={cerrarModal} 
              variant="outlined"
              sx={{ 
                borderColor: '#64748b',
                color: '#64748b'
              }}
            >
              Cancelar
            </Button>
            <Button 
              type="submit" 
              variant="contained" 
              sx={{ 
                bgcolor: '#3b82f6', 
                '&:hover': { bgcolor: '#2563eb' }
              }}
            >
              {editandoId ? 'Actualizar' : 'Crear'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      
      {/* Modal de motivo de pérdida */}
      <Dialog open={modalEtapaOpen} onClose={() => setModalEtapaOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: '#ef4444', color: 'white', fontWeight: 'bold', fontSize: '1.25rem' }}>
          ❌ ¿Por qué se perdió esta oportunidad?
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Describe el motivo de la pérdida. Ej: Competidor más barato, cliente no responde, presupuesto insuficiente, cambio de requerimientos..."
            value={motivoPerdida}
            onChange={(e) => setMotivoPerdida(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setModalEtapaOpen(false)} 
            variant="outlined"
            sx={{ 
              borderColor: '#64748b',
              color: '#64748b'
            }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => confirmarMoverEtapa('cerrado_perdido', motivoPerdida)}
            variant="contained" 
            color="error"
            disabled={!motivoPerdida.trim()}
          >
            Marcar como Perdida
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OportunidadesList;